module.exports = __webpack_public_path__ + "static/media/about-21.03b407ea.webp";